import React, { createContext, useContext } from "react";
import { useQuery } from "react-query";
import { makeAuthedRequest } from "../utils/makeAuthedRequest";
import { parseApiError } from "../utils/apiError";

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const query = useQuery("user", async () => {
    const res = await makeAuthedRequest("/user/profile");
    if (!res.ok) throw await parseApiError(res, "User fetch failed");
    return res.json();
  });

  return <UserContext.Provider value={query}>{children}</UserContext.Provider>;
}

export function useUser() {
  return useContext(UserContext);
}

// Profile response is { users: [...], isFreeTrial }
export function useIsFreeTrial() {
  const query = useUser();
  // return true
  return query?.data?.isFreeTrial ?? null;
}
